import { render, staticRenderFns } from "./addMonitorCFL.vue?vue&type=template&id=90fc7c5c&scoped=true&"
import script from "./addMonitorCFL.vue?vue&type=script&lang=js&"
export * from "./addMonitorCFL.vue?vue&type=script&lang=js&"
import style0 from "./addMonitorCFL.vue?vue&type=style&index=0&id=90fc7c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fc7c5c",
  null
  
)

export default component.exports